import { Attribute } from '../../../concepts/objects';
import { Frame } from './Frame';

export const FrameCameraScaleAttr = new Attribute<number, Frame>('cameraScale', 1);
export const FrameBorderWidthAttr = new Attribute<number, Frame>('borderWidth', 1);
export const FrameLabelFontSizeAttr = new Attribute<number, Frame>('labelFontSize', 12);
export const FrameUserElevatedAttr = new Attribute<boolean, Frame>('userElevated', false);
